import React, { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { formBtn1, formBtn3 } from "../Utils/CustomClasses";
import { DeleteGroupsAPI } from "../../API/Api";
import { toast } from "react-toastify";
import { IconTrash } from "@tabler/icons-react";

export default function DeleteGroupModal({ row, filterRecords }) {
    const [isOpen, setIsOpen] = useState(false)
    const toggle = () => {
        setIsOpen(!isOpen);
    };

    const onDelete = async () => {
        try {
            const response = await DeleteGroupsAPI(row?._id)            
            if (response?.status == 200) {
                toast.success(response?.data?.message);
                filterRecords();
                setIsOpen(false);
            }else{
                toast.error(response?.response?.data?.error)
            }
        } catch (err) {
            console.log('Error:', err)
        }
    }
    return (
        <>
            <button onClick={toggle} className='py-1 rounded-lg flex justify-center'>
               <IconTrash stroke={1.5} size={24} color='red'/>
            </button>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-[100]" onClose={toggle}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>
                    <div className="fixed inset-0 overflow-y-scroll">
                        <div className="flex items-center justify-center min-h-full p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-2xl overflow-hidden text-left align-middle transition-all transform bg-white rounded-lg shadow-xl">
                                    <Dialog.Title
                                        as="h2"
                                        className="w-full px-3 py-4 text-lg font-semibold leading-6 text-white bg-base-color font-tb"
                                    >
                                        Delete Group
                                    </Dialog.Title>
                                    <div className="p-4">
                                        <div className="flex items-center justify-center flex-col">
                                            <div>
                                                <h4 className='text-black base-font-inter font-bold pt-2 capitalize w-[300px] text-center'>Are you sure ?</h4>
                                            </div>
                                            <div>
                                                <h6>Do you really want to delete this record. This process cannot be undone</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <footer className="flex justify-end px-4 py-2 space-x-3 bg-white">
                                        <button
                                            type="button"
                                            className={`${formBtn1} px-4 py-2 text-white font-bold rounded-lg`}
                                            onClick={toggle}
                                        >
                                            Close
                                        </button>
                                        <button
                                            type="button"
                                            onClick={onDelete}
                                            className={`${formBtn3} px-4 py-2 text-white font-bold rounded-lg`}
                                        >
                                            Delete
                                        </button>
                                    </footer>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}
